export default "images/L1b.jpg";